export default function CardRow({
    card,
    index,
    selectedIndex,
    setSelectedIndex,
    swiperRef,
}) {
    const handleSelect = () => {
        console.log("RADIO CLICKED:", index);

        setSelectedIndex(index);

        if (swiperRef.current) {
            swiperRef.current.slideTo(index);
        }
    };

    return (
        <>
            {/* Desktop View */}
            <div className="hidden md:grid grid-cols-3 items-center gap-4 mb-4">

                <div className="flex items-center gap-3">
                    <label className="flex items-center gap-3 cursor-pointer">
                        <input
                            type="radio"
                            name="selectedCard"
                            value={index}
                            checked={selectedIndex === index}
                            onChange={handleSelect}
                            className="w-4 h-4"
                        />

                        <div className="border rounded-lg px-4 py-2 bg-gray-50 w-full">
                            {card.cardNumber}
                        </div>
                    </label>
                </div>

                <div className="border rounded-lg px-4 py-2 bg-gray-50 text-center">
                    {card.expiryDate}
                </div>

                <div className="border rounded-lg px-4 py-2 bg-gray-50 flex items-center justify-between">
                    Tokenized
                     <span className="material-symbols-outlined text-green-500">
                        check_circle
                    </span>
                </div>
            </div>


            {/* Mobile View */}
            <div
                className={`md:hidden border rounded-xl p-4 mb-3 transition ${
                    selectedIndex === index
                        ? "border-blue-600 bg-blue-50"
                        : "bg-gray-50"
                }`}
            >
                <div className="flex items-center justify-between mb-2">

                    <label className="flex items-center gap-2 cursor-pointer">
                        <input
                            type="radio"
                            name="selectedCardMobile"
                            value={index}
                            checked={selectedIndex === index}
                            onChange={handleSelect}
                            className="w-5 h-5 accent-blue-600"
                        />

                        <span className="text-gray-800 font-medium">
                            {card.cardNumber}
                        </span>
                    </label>

                    <span className="text-green-500 text-sm font-medium">
                        ✔
                    </span>
                </div>

                <div className="text-gray-500 text-sm">
                    Expiry: {card.expiryDate}
                </div>
            </div>
        </>
    );
}